export default __webpack_public_path__ + "static/media/clients-01.3d96b900.svg";